export default __webpack_public_path__ + "static/media/DocumentTypeTxt.4f308288.svg";